import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#050508]" data-testid="terms-page">
      <Navbar />

      <main className="pt-24 pb-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-heading text-3xl sm:text-4xl text-white mb-8">Terms of Service</h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#A1A1AA]">
            <section>
              <h2 className="font-heading text-xl text-white mb-4">1. Acceptance of Terms</h2>
              <p>
                By accessing and using Nexus Forge, you accept and agree to be bound by the terms and 
                provisions of this agreement. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">2. Use of Services</h2>
              <p>
                Our products are provided for educational and entertainment purposes only. You agree to use 
                our services responsibly and in accordance with applicable laws and game terms of service.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">3. Account Responsibility</h2>
              <p>
                You are responsible for maintaining the confidentiality of your account credentials and for 
                all activities that occur under your account. You agree to notify us immediately of any 
                unauthorized use of your account.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">4. License Keys</h2>
              <p>
                License keys are non-transferable and are valid only for the duration specified at purchase. 
                Sharing, selling, or distributing license keys to third parties is strictly prohibited.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">5. Service Availability</h2>
              <p>
                We strive to maintain service availability but do not guarantee uninterrupted access. 
                Products may be temporarily unavailable due to updates or maintenance. Check the Status 
                page for current availability.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">6. Limitation of Liability</h2>
              <p>
                Nexus Forge is not responsible for any consequences resulting from the use of our products, 
                including but not limited to game bans or account suspensions. Use at your own risk.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">7. Changes to Terms</h2>
              <p>
                We reserve the right to modify these terms at any time. Continued use of our services after 
                changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl text-white mb-4">8. Contact</h2>
              <p>
                For questions about these terms, please contact us through our{" "}
                <a href="https://discord.gg/efeySGKGJk" target="_blank" rel="noopener noreferrer" className="text-[#4F7CFF] hover:underline">
                  Discord server
                </a>.
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsPage;
